import React ,{useState,useEffect}from "react";
import FranchiseLanding from "./FranchiseLanding";
import About from "../About/About";
import Expert from "../Expert/Expert";
import Question from "../Question/Question";
import { Button } from "react-bootstrap";
import Footer from "../Footer/Footer";
import FranchiseForm from "../Franchise/FranchiseForm/FranchiseForm";
import FranchiseType from "../Franchise/FranchiseType/FranchiseType";
import Brochures from "../Franchise/Brochures/Brochures";
import FranchisePartner from "../Franchise/FranchisePartner/FranchisePartner";
import FranchiseNewsArticles from "../Franchise/FranchiseNewsArtivcle/FranchiseNewsArticles";
import BottomNavbar from "../BottomNavbar/BottomNavbar";
import FranchisePartnerMap from "../Franchise/FranchisePartnerMap/FranchisePartnerMap";
import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";
export default function FranchiseHome() {
   const [isMobile, setIsMobile] = useState(false);
    const [feedback, setFeedback] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const handleFeedback = (type) => {
      setFeedback(type);
      setSubmitted(true);
      // TODO: send to backend API if needed
    };
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      handleResize(); // initial check
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
  return (
    <>
      <FranchiseLanding />
      <About />
      <FranchiseForm />
      <br></br>
      <FranchisePartnerMap />
      <br></br>
      <FranchiseType />
      <br></br>
      <Brochures />
      <br></br>
      <FranchisePartner />
      <br></br>
      <FranchiseNewsArticles />
      <Expert />
      <Question />
      <br></br>
      <div className="mt-4 p-3 border-top">
        {!submitted ? (
          <>
            <p className="mb-2 fw-bold" style={{textAlign:"center"}}>Was this information helpful?</p>
            <div className="d-flex gap-3 flex-wrap justify-content-center">
              <Button
                variant="outline-success"
                className="d-flex align-items-center gap-2"
                onClick={() => handleFeedback("like")}
              >
                <FaThumbsUp /> Yes
              </Button>
              <Button
                variant="outline-danger"
                className="d-flex align-items-center gap-2"
                onClick={() => handleFeedback("dislike")}
              >
                <FaThumbsDown /> No
              </Button>
            </div>
          </>
        ) : (
          <p className="text-success mt-2" style={{textAlign:"center"}}>Thank you for your feedback! 🙏</p>
        )}
      </div>
      <br></br>
      <Footer />
      <BottomNavbar />
    </>
  );
}
